import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { AbreCuentasService } from '../../abre-cuentas/abre-cuentas.service';
import { CryptoVaultService } from '../../external/crypto-vault/crypto-vault.service';
import { ParametersService } from '../../parameters/parameters.service';
import { ChannelCommunicatorService } from '../channel-communicator/channel-communicator.service';
import { PlatformEndpointService } from '../endpoint/endpoint.service';
import { CipherCommunicatorService } from './cipher-communicator/cipher-communicator.service';
import { PlatformCommunicatorAuthService } from './platform-communicator.auth.service';
import { PlatformCommunicatorInterceptor } from './platform-communicator.interceptor';
import { RequestHeaderSettings } from './request.header.settings';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./platform-communicator.auth.service";
import * as i3 from "../../parameters/parameters.service";
import * as i4 from "./cipher-communicator/cipher-communicator.service";
import * as i5 from "../../abre-cuentas/abre-cuentas.service";
import * as i6 from "../../external/crypto-vault/crypto-vault.service";
import * as i7 from "../endpoint/endpoint.service";
import * as i8 from "../channel-communicator/channel-communicator.service";
/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
var PlatformCommunicatorService = /** @class */ (function () {
    /**
     * Constructor de la clase
     *
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @param {HttpClient} _http
     * @param {PlatformCommunicatorAuthService} authService
     */
    function PlatformCommunicatorService(_http, authService, parametersService, cipherCommunicator, abreCuentasService, cipherService, endpointService, channelCommunicatorService, interceptors) {
        var _this = this;
        this._http = _http;
        this.authService = authService;
        this.parametersService = parametersService;
        this.cipherCommunicator = cipherCommunicator;
        this.abreCuentasService = abreCuentasService;
        this.cipherService = cipherService;
        this.endpointService = endpointService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.interceptors = interceptors;
        /**
         * Definición de la variable parametrizedHeaders como HttpHeaders e indefinico
         *
         * *Defines parametrizedHeaders variable as HttpHeaders and undefined*
         *
         * @type {private}
         * @var {HttpHeaders} parametrizedHeaders
         */
        this.parametrizedHeaders = undefined;
        this.interceptors.forEach(function (interceptor) {
            if (interceptor instanceof PlatformCommunicatorInterceptor) {
                _this.communicatorInterceptor = interceptor;
            }
        });
    }
    /**
     * Función para procesar los headers
     *
     * *Function to process headers*
     *
     * @type {function}
     * @param {HttpHeaders} additionalHeaders
     * @returns {HttpHeaders} headers
     */
    PlatformCommunicatorService.prototype.processHeaders = function (additionalHeaders, url, isPpid, appendSession) {
        var e_1, _a;
        var _this = this;
        var requiredSpecificToken = (url === this.endpointService.URLS.GET_OTP || url === this.endpointService.URLS.VALIDATE_OTP)
            && this.abreCuentasService.getUserJemelii();
        console.log('///** REQUIRED TOKEN JEMELLI ' + requiredSpecificToken);
        var token = requiredSpecificToken ? this.authService.getSSOTokenForOTP().accessToken : this.authService.getSSOInformation().accessToken;
        var sessionId = this.authService.getSessionId();
        // const clientProduct = this.authService.clientProduct();
        var headers = RequestHeaderSettings.getHeaders(token, isPpid);
        // Colocarlo en el request service para esos 3
        if (url === this.endpointService.URLS.SEND_BACK_DOCUMENT_INFO ||
            url === this.endpointService.URLS.FRONT_DOCUMENT_INFO ||
            url === this.endpointService.URLS.FINGER_PRINTS_INFO ||
            url === this.endpointService.URLS.AGREEMENTS_OFFERS ||
            url === this.endpointService.URLS.GET_SIMULATION ||
            url === this.endpointService.URLS.TERMS_CONDITIONS) {
            headers = headers.append('use_cripto', 'false');
        }
        if (url !== this.endpointService.URLS.API_GATEWAY_SSO) {
            headers = headers.append('transaction_id', this.abreCuentasService.getTransactionId());
            headers = headers.append('channel-id', this.channelCommunicatorService.getChannelId().toString());
        }
        // TODO: se debe eliminar esta validacion cuando se implemente el nuevo apuntamiento al bff para listas restritivas
        if (url === this.endpointService.URLS.RESTRICTIVE_LIST ||
            url === this.endpointService.URLS.AGREEMENTS_LOAN) {
            headers = headers.append('token-client-id', this.abreCuentasService.getDocumentInfo().document_number + "_" + this.abreCuentasService.getDocumentInfo().document_type);
        }
        if (this.endpointService.URLS.DOCUMENTARY_SUFFICIENCY && url.split('?')[0] === this.endpointService.URLS.DOCUMENTARY_SUFFICIENCY.split('?')[0]) {
            headers = headers.append('token_client_id', this.abreCuentasService.getDocumentInfo().document_number + "_" + this.abreCuentasService.getDocumentInfo().document_type);
        }
        // TODO- revisar en ambiente
        if (this.endpointService.URLS.LOAD_FILE && url.split('?')[0] === this.endpointService.URLS.LOAD_FILE.split('?')[0] && !this.abreCuentasService.getPostlogin()) {
            console.log(this.abreCuentasService.getDocumentInfo());
            headers = headers.append('token-user-id', this.abreCuentasService.getDocumentInfo().document_number + "_" + this.abreCuentasService.getDocumentInfo().document_type);
        }
        if (token && this.parametrizedHeaders !== undefined) {
            var keys = this.parametrizedHeaders.keys();
            headers = headers.append('operation_target', this.parametrizedHeaders.get('operation_target'));
            keys.map(function (chKey) {
                // tslint:disable-next-line: early-exit
                if (chKey === _this.channelCommunicatorService.getChannelId() && _this.parametrizedHeaders !== undefined) {
                    var chHead = _this.parametrizedHeaders.get(chKey);
                    for (var key in chHead) {
                        if (Object.prototype.hasOwnProperty.call(chHead, key)) {
                            headers = headers.append(key, chHead[key]);
                        }
                    }
                }
            });
        }
        /* */
        // if (token && this.parametrizedHeaders !== undefined) {
        //   const keys = this.parametrizedHeaders.keys();
        //   for (const key of keys) {
        //     headers = headers.append(key, this.parametrizedHeaders.get(key) as string);
        //   }
        // }
        if (sessionId && appendSession) {
            headers = headers.append('session_id', sessionId);
        }
        if (additionalHeaders !== undefined) {
            var requestHeaders = additionalHeaders;
            var keys = headers.keys();
            try {
                for (var keys_1 = tslib_1.__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                    var key = keys_1_1.value;
                    if (requestHeaders.get(key) === null) {
                        requestHeaders = requestHeaders.append(key, headers.get(key));
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            headers = requestHeaders;
        }
        return headers;
    };
    /**
     * Función que inicializa los headers parámetrizados
     *
     * *Function that sets parametrized headers*
     *
     * @type {function}
     * @param {HttpHeaders} parametrizedHeaders
     */
    PlatformCommunicatorService.prototype.setParametrizedHeaders = function (parametrizedHeaders) {
        this.parametrizedHeaders = parametrizedHeaders;
        this.abreCuentasService.setParametrizedHeaders(parametrizedHeaders);
    };
    /**
     * Solicitud que configura los parámetros de acuerdo un método de solicitud HTTP
     *
     * *Request that sets params up according to a specific HTTP request*
     *
     * @type {function}
     * @param {IWebRequestOptions} options
     * @param {boolean} encrypted
     * @returns {Promise<HttpResponse<any>>}
     */
    PlatformCommunicatorService.prototype.request = function (options, encrypted, isPpid, appendSession) {
        if (isPpid === void 0) { isPpid = false; }
        if (appendSession === void 0) { appendSession = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var headers;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = this.processHeaders(options.headers, options.url, isPpid, appendSession);
                        options.headers = headers;
                        if (!(encrypted && options.body)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.cipherService.encrypt(JSON.stringify(options.body)).then(function (data) {
                                options.body = {
                                    data: {
                                        message: data,
                                    },
                                };
                            }, function (err) {
                                return err;
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            var fucntionParameters;
                            var url = _this.getURLRequest(options.url, options.method);
                            if (url !== options.url) {
                                options.method = 'get';
                            }
                            if (options.method !== 'get' && options.method !== 'delete') {
                                fucntionParameters = [
                                    options.url,
                                    options.body,
                                    { headers: headers, params: options.params, observe: 'response' },
                                ];
                            }
                            else {
                                fucntionParameters = [
                                    url,
                                    { headers: headers, params: options.params, observe: 'response' },
                                ];
                            }
                            _this._http[options.method].apply(_this._http, fucntionParameters).toPromise().then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var decryptedResponse, decryptResponse;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(response.status === 200)) return [3 /*break*/, 3];
                                            if (!(encrypted && (options.body || response.body != null) && response.body.data)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.cipherService.decrypt(response.body.data.message)];
                                        case 1:
                                            decryptedResponse = _a.sent();
                                            decryptResponse = {
                                                body: JSON.parse(decryptedResponse),
                                                status: response.status,
                                                ok: true,
                                                headers: response.headers,
                                                statusText: response.statusText,
                                                type: response.type,
                                                url: response.url,
                                                clone: response.clone,
                                            };
                                            console.warn('request--', decryptResponse);
                                            resolve(decryptResponse);
                                            _a.label = 2;
                                        case 2:
                                            resolve(response);
                                            return [2 /*return*/];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); }, function (error) {
                                if (encrypted) {
                                    var decryptederror = _this.cipherService.decrypt(error.error.data.message);
                                    console.warn('decryptederror', decryptederror);
                                    error.status === 422 && error.url.indexOf('/otp/') > 0 ? resolve(JSON.parse(decryptederror)) : reject(error);
                                    return;
                                }
                                reject(error);
                                return;
                            }).catch(function (error) {
                                reject(error);
                                return;
                            });
                        })];
                }
            });
        });
    };
    PlatformCommunicatorService.prototype.getURLRequest = function (url, method) {
        var backendURLMocked = this.parametersService.getParameter('url_mock_backend');
        if (backendURLMocked) {
            return this.communicatorInterceptor.getBackEndURLMocked(backendURLMocked, url, method);
        }
        return url;
    };
    PlatformCommunicatorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlatformCommunicatorService_Factory() { return new PlatformCommunicatorService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.PlatformCommunicatorAuthService), i0.ɵɵinject(i3.ParametersService), i0.ɵɵinject(i4.CipherCommunicatorService), i0.ɵɵinject(i5.AbreCuentasService), i0.ɵɵinject(i6.CryptoVaultService), i0.ɵɵinject(i7.PlatformEndpointService), i0.ɵɵinject(i8.ChannelCommunicatorService), i0.ɵɵinject(i1.HTTP_INTERCEPTORS)); }, token: PlatformCommunicatorService, providedIn: "root" });
    return PlatformCommunicatorService;
}());
export { PlatformCommunicatorService };
